import { defineEvent } from '../types/event';
export var MINICART_OPEN = defineEvent({
    platforms: [
        {
            name: 'Heap',
            alias: 'miniCartView'
        }
    ]
});
